import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import { colors } from "@/utils/const";
import CustomText from "../text";

function SectionContentSide({ content, withBg = false }) {
  const subtitleColor = withBg ? colors.white : colors.blue;
  const titleColor = withBg ? colors.dark_yellow : colors.orange;
  const paragraphColor = withBg ? colors.white : "#000";

  const wrapperSx = useMemo(
    () => ({ mb: withBg ? "50px" : undefined }),
    [withBg],
  );
  const titleStyle = useMemo(
    () => ({
      color: titleColor,
      fontWeight: 700,
      lineHeight: 1,
      my: { xs: 2, md: 1 },
    }),
    [titleColor],
  );

  const paragraphStyle = useMemo(
    () => ({
      color: paragraphColor,
      mb: 1.5,
      lineHeight: 1.5,
    }),
    [paragraphColor],
  );
  return (
    <Box sx={wrapperSx}>
      {content?.subtitle && (
        <CustomText
          text={content.subtitle}
          type="l"
          customStyle={{ color: subtitleColor }}
          variant={content?.subtitleType || "body1"}
        />
      )}
      {content?.title && (
        <CustomText
          text={content.title}
          type="xl"
          customStyle={titleStyle}
          variant={content?.titleType || "h2"}
        />
      )}

      {content?.description && (
        <CustomText
          text={content.description}
          type="xs"
          customStyle={paragraphStyle}
          variant={content?.descType || "body2"}
          enableHtml={true}
        />
      )}

      {content?.footer && (
        <CustomText
          text={content.footer}
          type="l"
          customStyle={{
            color: colors.blue,
            lineHeight: 1.2,
          }}
          variant={content?.noteType || "body2"}
        />
      )}
    </Box>
  );
}

export default memo(SectionContentSide);
